<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Категории шрифтов</h4>
                            <p class="card-category"></p>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('grf_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Активна</option>
                                            <option value="0">Не активна</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить категорию
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'name'">название</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'translations'">переводы</span>
                                        <span v-else-if="column === 'object_count'">количество объектов</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'translations'">{{ item[column] }}</span>
                                            <span v-else-if="column === 'name'">
                                                <a class="text-default" @click="edit(item['id'])">{{ item[column] }}</a>
                                            </span>
                                            <span v-else-if="column === ''">
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                              </span>
                                                                    <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Активна</span>
                                                <span class="text-warning" v-if="item[column] === 0">Не активна</span>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        this.init();
    },
    data() {
        return {
            columns: ['id', 'name', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('gfcat_status') ? localStorage.getItem('gfcat_status') : "",
            loading: false
        }
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            this.get();
        },
        add: function () {
            this.$router.push('/font/categories/create');
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(
                `${this.$hostname}/admin/fonts/categories`,
                {
                    'params': {
                        status: this.status,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                    localStorage.setItem('fonts-categories', JSON.stringify(response.data));
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-fonts-category',
                params: {id: id}
            });
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('font/categories') < 1) {
            localStorage.setItem('gfcat_status', "");
        }
        next();
    },
}
</script>
<style scoped>

.mt10 {
    margin-top: 10px;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.text-default {
    cursor: pointer;
    color: #000;
}
.text-success, .text-warning {
    font-weight: 700 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FontsCategories.vue